import React from 'react';
import {TCutState} from 'modules/cut';
import {convertSecondToTime} from 'lib/utils';
import {TDisplayWarn} from 'hooks/useEditWarn';
import {t} from 'lib/i18n';

interface IEditModeProps {
  time: number;
  cut: TCutState;
  displayEditWarn: TDisplayWarn;
  onChangeTime: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClickMode: () => void;
}

const inputLength = 5;

/**
 * 편집 모드(좌측 UI) 컴포넌트
 */
const EditMode = ({
  time,
  cut,
  displayEditWarn,
  onChangeTime,
  onClickMode,
}: IEditModeProps) => {
  const modeState = {
    cssClass: '',
    text: t('컷 편집'),
  };
  if (cut.status) {
    modeState.cssClass = 'btn_cut_editor_close';
    modeState.text = t('종료');
  }

  return (
    <div className='left_posi'>
      <span className='input_wrap '>
        <input
          data-tip={t('시 : 분 : 초')}
          maxLength={inputLength}
          value={convertSecondToTime(time)}
          onChange={onChangeTime}
        />
      </span>
      <button
        type='button'
        className={`btn_cut_editor ${modeState.cssClass}`}
        onClick={onClickMode}>
        {modeState.text}
      </button>
      {displayEditWarn.display && (
        <p>
          <em>!</em>
          {t(
            '장면 {{sectionIdx}}에서 구간이 선택되지 않았습니다. 파란 영역을 조절해 저장할 구간을 선택하세요.',
            {placeholder: {sectionIdx: displayEditWarn.sectionIdx}},
          )}
        </p>
      )}
    </div>
  );
};

export default EditMode;
